import { useState, useContext, useEffect } from 'react';

import { Box, Select, SelectChangeEvent } from '@parspec/pixel';

import { ICellRendererParams } from '@ag-grid-community/core';

import { TableContext } from '../../shared/context';
import { MainProductDataType } from '../mainProductTable';
import { OptionDataType } from '../optionsTable';

const options = [
    { label: '1', value: '1' },
    { label: '100 C', value: '100' },
    { label: '1000 M', value: '1000' }
];

interface SelectTemplateProps {
    onChange: (e: SelectChangeEvent<unknown>) => void;
    selectedValue: string;
    options: { label: string; value: string }[];
    fieldName?: string;
    showLabel?: boolean;
    disable: boolean;
}

function SelectTemplate({
    onChange,
    selectedValue,
    options,
    fieldName = '',
    showLabel = false,
    disable = false
}: SelectTemplateProps) {
    return (
        <Box width={1} pt={2}>
            <Select
                name={fieldName}
                size="xs"
                label={showLabel ? 'Select Value' : ''}
                onChange={onChange}
                optionLabelKeyname="label"
                optionValueKeyname="value"
                options={options}
                value={selectedValue || options[0].value}
                disabled={disable}
            />
        </Box>
    );
}

function PerTemplate(props: ICellRendererParams<any, any, any>) {
    const { data, value } = props;
    const { handlePerValue } = useContext(TableContext);
    const [dropdownVal, setDropdownVal] = useState(options[0].value);
    useEffect(() => {
        if (data.is_kit) {
            setDropdownVal("1")
        }
        if (dropdownVal !== value && !data.is_kit) {
            setDropdownVal(value);
        }
    }, [value]);

    async function handleOnChange(e: SelectChangeEvent<unknown>) {
        const value = e.target.value as string;
        setDropdownVal(value);
        let payload: Partial<MainProductDataType | OptionDataType> = { id: data.id, per: Number(value) };

        if (value === '-') {
            payload = { ...payload, per: null };
        }

        handlePerValue?.(props?.node, payload);
    }
    if (props?.node?.rowPinned === 'bottom') {
        return null;
    }
    if (props?.node?.level === 0) {
        return;
    }
    return (
        <SelectTemplate
            onChange={handleOnChange}
            options={options}
            selectedValue={dropdownVal}
            disable={data.is_kit}

        />
    );
}

export default PerTemplate;
